import { useState, useEffect } from 'react';
import { useNavigate, useParams, Link } from 'react-router-dom';
import { useNotification } from "../../contexts/NotificationContext";
import { authFetch } from '../../utils/authFetch';

const EditarFuncao = () => {
    const { id } = useParams();
    const { showNotification } = useNotification();
    const navigate = useNavigate();

    const [name, setName] = useState('');
    const [jobPositionType, setJobPositionType] = useState(0);

    useEffect(() => {
        const fetchFuncao = async () => {
            try {
                const response = await authFetch(`job-position/${id}`, {
                });

                if (!response.ok) throw new Error('Erro ao buscar função');

                const data = await response.json();
                setName(data.name);
                setJobPositionType(data.jobPositionType ?? 0);
            } catch (error) {
                console.error(error);
                showNotification("danger", "Erro ao buscar função");
            }
        };

        fetchFuncao();
    }, [showNotification]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const response = await authFetch('job-position', {
                method: 'PUT',
                body: JSON.stringify({ id, name, jobPositionType: jobPositionType })
            });

            if (!response.ok) throw new Error('Erro ao atualizar função');

            showNotification("success", "Função atualizada com sucesso!");
            navigate('/Funcoes');
        } catch (error) {
            console.error(error);
            showNotification("danger", "Erro ao atualizar função");
        }
    };

    return (
        <div className="card">
            <div className="card-body p-3">
                <div className="row">
                    <aside className="column">
                        <div className="side-nav">
                            <h4 className="font-weight-bolder mb-0">Editar Função</h4>
                        </div>
                    </aside>
                    <div className="column-responsive column-80">
                        <div className="usuarios form content">
                            <form onSubmit={handleSubmit}>
                                <fieldset className="col-md-6">
                                    <div className="mb-3">
                                        <label>Nome</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={name}
                                            onChange={(e) => setName(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label>Tipo</label>
                                        <select
                                            className="form-control"
                                            value={jobPositionType}
                                            onChange={(e) => setJobPositionType(parseInt(e.target.value))}
                                        >
                                            <option value={0}>Mensal</option>
                                            <option value={1}>Horas</option>
                                        </select>
                                    </div>
                                    <div className="card-footer" style={{ paddingLeft: "0" }}>
                                        <Link to={'/Funcoes'} className="btn btn-info btn-sm" >Voltar</Link>
                                        <button type="submit" className="btn btn-primary btn-sm mx-1">Salvar</button>
                                    </div>
                                </fieldset>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EditarFuncao;
